<script>
  export let shape
  export let active
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<svg
  on:click={() => {
    active = shape.id
  }}
  id={shape.id}
  viewBox="0 0 400 400"
  class="max-h-[130px] cursor-pointer {active == shape.id ? 'bg-slate-500' : ''} rounded-md p-2"
>
  {#each shape.data as path}
    <path fill={path.fill} d={path.d} />
    <!-- <path fill={path.fill} id={path.id} d={path.d} /> -->
  {/each}
</svg>
